import { route } from "src/vars";

/**
 * 인증 흐름 자체의 경로(인가 요청용 로그인 페이지, 인증 서버 콜백).
 * 복귀 대상이 되면 인증 완료 후 다시 인가 요청이 일어나 무한 루프가 된다.
 */
const AUTH_FLOW_PATH_PATTERN = /(^|\/)(login|callback)(\/|\?|$)/;

/**
 * 저장된 복귀 경로에서 basename 을 제거해 라우터 경로로 변환한다.
 */
function stripBasename(uri: string) {
  const index = uri.indexOf(route.basename);
  return index >= 0 ? uri.substring(index + route.basename.length) : uri;
}

/**
 * 인증 완료 후 돌아갈 라우터 경로를 결정한다.
 * 저장된 경로가 없거나 인증 흐름 경로면 fallback 을 사용한다.
 *
 * @param uri 저장된 복귀 경로(basename 포함 가능)
 * @param fallback 복귀 경로를 쓸 수 없을 때 이동할 경로
 */
export function resolveReturnUri(uri?: string, fallback: string = route.mainPath): string {
  if (!uri) return fallback;
  const returnUri = stripBasename(uri);
  if (!returnUri || AUTH_FLOW_PATH_PATTERN.test(returnUri)) return fallback;
  return returnUri;
}
